// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2zzOK","bigColWidth":"Table_bigColWidth__1yn4c","biggerColWidth":"Table_biggerColWidth__2hINj","row":"Table_row__1dxtU","col":"Table_col__2Ip5U"};